import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';
import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn';
import { tooltipPopupMotion } from '../lib/motion';

/** 첫 표시 지연 — Base UI 기본 600ms는 작업대에서 길다(D3 §4.5). 하나가 떠 있으면 옆 트리거는 즉시 바뀐다. */
export const TOOLTIP_DELAY_MS = 400;

export function TooltipProvider({
  delay = TOOLTIP_DELAY_MS,
  ...props
}: ComponentProps<typeof BaseTooltip.Provider>) {
  return <BaseTooltip.Provider delay={delay} {...props} />;
}
export const TooltipRoot = BaseTooltip.Root;
export const TooltipTrigger = BaseTooltip.Trigger;

export function TooltipPopup({ className, ...props }: ComponentProps<typeof BaseTooltip.Popup>) {
  return (
    <BaseTooltip.Popup
      className={cn(
        'bg-brand-900 shadow-pop py-tight rounded-md px-2.5 text-xs font-medium text-white',
        tooltipPopupMotion,
        className,
      )}
      {...props}
    />
  );
}

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  sideOffset?: number;
}

/** 아이콘 전용 버튼의 보조 설명. `aria-label`을 대체하지 않는다 — L2-06 §8. */
export function Tooltip({ content, children, sideOffset = 6 }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children as never} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner sideOffset={sideOffset} className="z-popover">
          <TooltipPopup>{content}</TooltipPopup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
